import * as React from 'react';
import { Typography, IconButton } from '@bb-ui/react-library';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { ChevronRight } from '@bb-ui/icons/dist/small';

export interface ViewReleaseStageButtonProps {
  releaseStageID: string;
}

export const ViewReleaseStageButton: React.FunctionComponent<ViewReleaseStageButtonProps> = ({
  releaseStageID,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <IconButton onClick={() => history.push(`/tenants/${releaseStageID}/jobs`)}>
      <Typography component="span" variant="inherit">
        {t('releaseStages.releaseStageViewDetailButton')}
      </Typography>
      <ChevronRight data-testid="ChevronRightIcon" />
    </IconButton>
  );
};
